import createSavingArrElement from "./create_saving_arr_element";
import DataObjectsTemplate from "../../../../datasets/data_object_templates";
import getCurrentPriceArr from "../../xMoneyBuilderObjects/get_current_price_arr";
 
export const createSavingsUpdateObj=(newSavingsSw, savingsInfo, savingsInfoArr, gameID,
        currentGameDate, companyMatchRate, gameNbrMonths, CDList, levelNbr) =>{
    // savingsInfo is the database savings record
    // savingsInfoArr is the array that contains the input values from the SetupSavingsModal
    let savingsArr = [];
    if (newSavingsSw === false){
        savingsArr = savingsInfo.savingsArr;
    }
    let savingsTranArr = [];
    let cashChgAmt = 0;
    let currentPriceArr = getCurrentPriceArr(gameNbrMonths);

    for (let i=0; i<savingsInfoArr.length; i++){
        const savingInfo = savingsInfoArr[i];
        if (savingInfo.updated === true){
            let currentSavingsObj = {};
            if (savingInfo.createNewElementSw === false){
                currentSavingsObj = savingsInfo.savingsArr[savingInfo.svgIndx];
            }
            let currentPrice = 0;
            if (savingInfo.savingsClass === "retirement"){
                currentPrice = currentPriceArr.find(elem => elem.retirementType === savingInfo.savingsType).currentPrice;
            }
            let newSavingsInfo = createSavingArrElement(savingInfo, newSavingsSw, currentGameDate, 
                currentSavingsObj, cashChgAmt, currentPrice, gameID, CDList);
            //  cashChgAmt from newSavingsObj is the total change to cash for this savingsInfoArr object
            //  including deposit, transfer amount and transfer fee
            cashChgAmt += +newSavingsInfo.cashChgAmt;
            if (newSavingsInfo.newSavingsArrSw === true){
                if (savingInfo.monthlyDepositAmt > 0 || savingInfo.oneTimeDepositAmt > 0){
                    savingsArr.push(newSavingsInfo.savingsArrObj);
                }
            }else{
                const svgIndx = savingInfo.svgIndx;
                savingsArr[svgIndx] = newSavingsInfo.savingsArrObj;
            }
            savingsTranArr.push(newSavingsInfo.tranArrObj);
        }
    }
    let currentlyActive = false;
    for (let i=0; i<savingsArr.length; i++){
         if (savingsArr[i].closedDate === ""){
            currentlyActive = true;
            break;
         }
    }
    if (newSavingsSw === true){
        const savingsInfoObj = 
                DataObjectsTemplate.find(elem => elem.dataType === "savingsInfoObj").savingsInfo;
        savingsInfo = JSON.parse(JSON.stringify(savingsInfoObj));
        savingsInfo.gameID = gameID;
    }
    savingsInfo.savingsArr = savingsArr;
    savingsInfo.currentlyActive = currentlyActive;
    savingsInfo.level = levelNbr;
  
    savingsInfo.companyMatchRate = companyMatchRate.toString();
    const returnObj = {savingsInfoObj: savingsInfo, savingsTranArr: savingsTranArr, cashAmt: cashChgAmt};
    return returnObj;
}

export default createSavingsUpdateObj;